import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Register from "../Register/Register";
import YowRegister from "../Register/YowRegister";
import Translate from "../../../Components/Multilanguage/Translate";

const BenefitRow = ({ feature, benefits }) => {
	const renderCell = (b) => {
		const feats = b.features || [];
		const entry = feats.find((f) => (typeof f === 'string' ? f === feature.id : f && f.id === feature.id));

		if (entry && entry.value) {
			return <span className="price-text">{entry.value}</span>;
		}

		const present = !!entry;
		return present ? <span className="check">✓</span> : <span className="dash">-</span>;
	};

	return (
		<div className="benefit-row">
			<div className="label">{feature.title}</div>
			{benefits.map((b, i) => (
				<div key={b.title + i} className={`col col-${i}`}>
					{renderCell(b)}
				</div>
			))}
		</div>
	);
};

const Checkout2 = () => {
	const projectInfo = useSelector((state) => state?.projectInfo?.value);
	const subscriber = projectInfo?.projectConfig?.config?.SUBSCRIBER_BENEFITS;
	const features = subscriber?.features || [];
	const benefits = subscriber?.benefits || [];

	const tableRef = useRef(null);
	const colRefs = useRef([]);
	const labelRef = useRef(null);
	const leftCardRef = useRef(null);
	const [colMetrics, setColMetrics] = useState(null);

	const initialSelected = benefits.findIndex((b) => b?.choose_plan_required === true);
	const [selectedPlanIndex, setSelectedPlanIndex] = useState(initialSelected >= 0 ? initialSelected : -1);

	const gridColsStyle = benefits && benefits.length > 0 ? { gridTemplateColumns: `1fr ${benefits.map(() => '120px').join(' ')}` } : {};

	useEffect(() => {
		const measure = () => {
			if (!tableRef.current) return;
			const tableRect = tableRef.current.getBoundingClientRect();
			const labelRect = labelRef.current ? labelRef.current.getBoundingClientRect() : null;
			const firstColRect = (colRefs.current && colRefs.current[0]) ? colRefs.current[0].getBoundingClientRect() : null;
			const leftCardRect = leftCardRef.current ? leftCardRef.current.getBoundingClientRect() : { left: tableRect.left };
			const cols = (colRefs.current || []).map((el) => {
				if (!el) return null;
				const r = el.getBoundingClientRect();
				return { left: r.left + window.scrollX - tableRect.left, width: r.width };
			});
			setColMetrics({
				tableLeft: tableRect.left + window.scrollX,
				tableTop: tableRect.top + window.scrollY,
				leftCardLeft: leftCardRect.left + window.scrollX,
				tableHeight: tableRect.height,
				tableHeightAdjusted: Math.max(0, tableRect.height),
				headerHeight: Math.max(labelRect ? labelRect.height : 0, firstColRect ? firstColRect.height : 0),
				columns: cols,
			});
		};
		measure();
		window.addEventListener("resize", measure);
		window.addEventListener("orientationchange", measure);
		return () => {
			window.removeEventListener("resize", measure);
			window.removeEventListener("orientationchange", measure);
		};
	}, [benefits.length]);

	useEffect(() => {
		const firstChoose = benefits.findIndex((b) => b?.choose_plan_required === true);
		if (firstChoose >= 0) {
			setSelectedPlanIndex(firstChoose);
		} else {
			setSelectedPlanIndex(-1);
		}
		if (benefits.length > 0 && selectedPlanIndex >= benefits.length) {
			setSelectedPlanIndex(-1);
		}
	}, [benefits]);

	const onChoose = (index) => {
		setSelectedPlanIndex(index);
	};

	const getSelectedPlan = () => (selectedPlanIndex >= 0 && benefits && benefits[selectedPlanIndex] ? benefits[selectedPlanIndex] : null);

	if (projectInfo?.projectConfig?.pubid === 50187) {
		return <YowRegister />;
	}

	return (
		<div className="checkout2-page">
			<div className="checkout2-wrapper">
				<div className="left-card" ref={leftCardRef}>
					<h2 className="title"><Translate textKey="plan_benefits" /></h2>
					<div className="benefits-table" ref={tableRef} style={gridColsStyle}>
						{selectedPlanIndex >= 0 && colMetrics && colMetrics.columns && colMetrics.columns[selectedPlanIndex] && (
							<div
								className="column-bg"
								style={{
									left: `${colMetrics.columns[selectedPlanIndex].left}px`,
									width: `${colMetrics.columns[selectedPlanIndex].width}px`,
								}}
							/>
						)}

						<div className="header-row">
							<div className="label" ref={labelRef}>&nbsp;</div>
							{benefits && benefits.length > 0 && benefits.map((b, i) => (
								<div
									key={b.title + i}
									className={`col col-${i}`}
									ref={(el) => (colRefs.current[i] = el)}
								>
									<div className="col-title">{b.title}</div>
								</div>
							))}
						</div>

						{(features || []).map((f) => (
							<BenefitRow key={f.id} feature={f} benefits={benefits} />
						))}

						{colMetrics && colMetrics.columns && benefits && benefits.length > 0 && (
							<>
								{benefits.map((b, i) => (
									b?.choose_plan_required ? (
										colMetrics.columns[i] ? (
											<div
												key={b.title + i}
												className={`plan-button plan-${i}`}
												style={{ left: `${colMetrics.columns[i].left + colMetrics.columns[i].width / 2}px` }}
												>
													<button
														className={`choose-plan ${selectedPlanIndex === i ? "active" : ""}`}
														onClick={() => onChoose(i)}
													>
														<Translate textKey={'choose_plan_caps'} />
													</button>
												</div>
										) : null
									) : null
								))}
							</>
						)}

					</div>


				</div>

				<div className="right-panel">
					{(() => {
						const plan = getSelectedPlan();
						const newCheckoutRequired = projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === "true";
						if (plan && plan.go_to_checkout) {
							return <Register redirectPath={newCheckoutRequired ? "/checkout" : "/subscription"} />;
						}
						return <Register redirectPath="/home" />;
					})()}
				</div>
			</div>
		</div>
	);
};

export default Checkout2;
